export default function redWhiteBlocks(widget, opts, colorBlock) {
  return new Promise((resolve) => {
    const widgetName = widget;
    const widgetOpts = opts;
    const $widget = $(`#${widgetName}`);

    saffire.widgets.cardWidget($widget, {
      currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
      scriptPath: widgetOpts.scriptPath,

      cardWidgetLoaded: function (data, _owl, hasData) {
        if (hasData && Array.isArray(data.items)) {
          const newData = data.items.map((item, index) => ({
            id: index,
            color: colorBlock,
            Title: item.Title || '',
            Description: item.Description || '',
            URL: item.URL || '',
            Image: item.ImageWithPath || '',
          }));
          resolve(newData);
        } else {
          $widget.remove();
          resolve([]);
        }
      },
    });
  });
}
